/**
 * @generated SignedSource<<67794817116ec0e6292de7337ed284cf>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type storyPointEstimate_issueFieldStoryPointEstimateReadviewFull_StoryPointEstimateReadView$data = {
  readonly hoverOrFocusState?: {
    readonly " $fragmentSpreads": FragmentRefs<"popoverWithRelay_hoverPopover_HoverPopoverWithRelayComponent">;
  } | null | undefined;
  readonly number: number | null | undefined;
  readonly " $fragmentType": "storyPointEstimate_issueFieldStoryPointEstimateReadviewFull_StoryPointEstimateReadView";
};
export type storyPointEstimate_issueFieldStoryPointEstimateReadviewFull_StoryPointEstimateReadView$key = {
  readonly " $data"?: storyPointEstimate_issueFieldStoryPointEstimateReadviewFull_StoryPointEstimateReadView$data;
  readonly " $fragmentSpreads": FragmentRefs<"storyPointEstimate_issueFieldStoryPointEstimateReadviewFull_StoryPointEstimateReadView">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelineeventdelegatorenabledrelayprovider"
    }
  ],
  "kind": "Fragment",
  "name": "storyPointEstimate_issueFieldStoryPointEstimateReadviewFull_StoryPointEstimateReadView",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "number"
    },
    {
      "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelineeventdelegatorenabledrelayprovider",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "ClientExtension",
          "selections": [
            {
              "concreteType": "JiraFieldHoverOrFocusState",
              "kind": "LinkedField",
              "name": "hoverOrFocusState",
              "plural": false,
              "selections": [
                {
                  "kind": "FragmentSpread",
                  "name": "popoverWithRelay_hoverPopover_HoverPopoverWithRelayComponent"
                }
              ]
            }
          ]
        }
      ]
    }
  ],
  "type": "JiraNumberField"
};

(node as any).hash = "b27fc7b3ab28f3fc9625eb48fa4324be";

export default node;
